import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import AccountForm from './AccountForm';
import {sectionStyles} from '../../styles/sectionStyles';
import {withStyles} from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress/LinearProgress';
import {Redirect} from 'react-router-dom';
import {
  fetchAccount,
} from '../../store/actions/accountActions';

class AccountEdit extends React.Component {
  componentDidMount() {
    if (!this.props.auth.accessToken) {
      return;
    }
    this.props.fetchAccount(this.props.id);
  }

  render() {
    const {classes, auth} = this.props;

    if (!auth.accessToken) {
      return <Redirect to='/signin' />
    }

    const {account, isFetching, error} = this.props.activeAccount;

    if (isFetching) {
      return (
          <LinearProgress />
      )
    }

    if (error) {
      return (
          <p>{error}</p>
      )
    }

    return (
        <AccountForm account={account} className={classes.wrapperSection}/>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id;
  return {
    id,
    auth: state.auth,
    activeAccount: state.account.activeAccount,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAccount: (id) => dispatch(fetchAccount(id)),
  }
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(sectionStyles)
)(AccountEdit);